import {
  compose,
  componentFromProp,
  withStateHandlers,
  mapProps,
  withHandlers,
  lifecycle,
  withPropsOnChange,
} from 'recompose'
import { connect } from 'react-redux'

import get from 'lodash/get'
import map from 'lodash/map'
import isObject from 'lodash/isObject'
import toString from 'lodash/toString'
import set from 'lodash/set'

import { withDebounce, Multiselect, Combobox } from '@infotech/base-components'

// конвертируем в строку, так как сервер будет ожидать строку
const convertToServerResponse = (response, entity, valueField) => {
  const items = get(response, `response.json.entities.${entity}`)
  return map(items, (item) => {
    set(item, valueField, toString(get(item, valueField)))

    return item
  })
}

const dataEnhancer = compose(
  withStateHandlers(({ input: { value } }) => ({
    data: [],
    busy: false,
    value,
  }), {
    setAutoCompleteData: () => (data) => ({ data }),
    changeBusy         : () => (busy) => ({ busy }),
  }),
  connect(null, (dispatch, {
    setAutoCompleteData, changeBusy, entity, valueField,
  }) => ({
    getAutoCompleteData: (apiAction, search) => {
      if (!search) {
        changeBusy(false)
        return setAutoCompleteData([])
      }
      changeBusy(true)
      return dispatch(apiAction(search)).then((response) => {
        changeBusy(false)
        if (!response.error) {
          setAutoCompleteData(convertToServerResponse(response, entity, valueField))
        }
      })
    },
  })),
  withHandlers({
    getAutoCompleteDataByValue: ({ apiActionByValue, getAutoCompleteData }) => (value) => (
      getAutoCompleteData(apiActionByValue, value)
    ),
    getAutoCompleteDataByText: ({ apiActionByText, getAutoCompleteData }) => (text) => (
      getAutoCompleteData(apiActionByText, text)
    ),
  }),
  withHandlers({
    onSelect: ({ input: { onChange }, valueField }) => (value) => {
      onChange(toString(value[valueField]))
    },
    onChange: ({ input: { onChange }, getAutoCompleteDataByText }) => (search) => {
      if (!isObject(search)) {
        getAutoCompleteDataByText(search)
        onChange(search)
      }
    },
  }),
  lifecycle({
    componentDidMount() {
      this.props.getAutoCompleteDataByValue(get(this.props, `input.value`))
    },
  }),
  withDebounce,
)

const choiceViewEnhancer = compose(
  withPropsOnChange([`multiple`], ({ multiple }) => ({
    component: multiple ? Multiselect : Combobox,
  })),
)

const createAutoCompleteComponent = ({
  entity,
  apiActionByValue,
  apiActionByText,
  valueField = `id`,
  textField = `name`,
  multiple = false,
  itemComponent,
}) => compose(
  mapProps(({ input }) => ({
    entity,
    apiActionByValue,
    apiActionByText,
    valueField,
    textField,
    multiple,
    itemComponent,
    input,
  })),
  dataEnhancer,
  choiceViewEnhancer,
)(componentFromProp(`component`))

export default createAutoCompleteComponent
